import styles from "./jetpass-intro.module.less";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import { GhostButton, PrimaryButton, SessionStorageHelper } from "@parksandresorts/core";

const JetpassIntro = (props) => {
  const introHeadLine = SiteConfigurationStore.getLabel("JETPASS_INTRO_HEADLINE", "Gå före i kön med JetPass");
  const introPreamble = SiteConfigurationStore.getLabel(
    "JETPASS_INTRO_PREAMBLE",
    "Till denna produkt ingår %number% JetPass.",
  );
  const introDescription = SiteConfigurationStore.getLabel(
    "JETPASS_INTRO_DESCRIPTION",
    "De gör att du går före i kön när du bokat en tid.",
  );
  const bookNowButton = SiteConfigurationStore.getLabel("JETPASS_INTRO_BOOK_NOW_BUTTON", "Boka pass nu!");
  const optOutButton = SiteConfigurationStore.getLabel("JETPASS_INTRO_OPT_OUT_BUTTON", "Jag vill inte boka JetPass");
  const introPreambleWithText = introPreamble.replace(
    /%number%/gi,
    props.numberOfTotalPasses ? props.numberOfTotalPasses : "",
  );

  SessionStorageHelper.setItem("jetPassIntroSeen", true);

  return (
    <div className={`${styles.wrapper} block--max-width-narrow`}>
      <h2 className={["h1", styles.headline].join(" ")}>{introHeadLine}</h2>
      <p className={`${styles.preamble} preamble`}>{introPreambleWithText}</p>
      <div className={[styles.imageWrapper]}>
        <img className={styles.jetpassImage} src="/images/jetpass/jetpass_logo_color.png" alt="JetPass" />
      </div>
      <p className={styles.description}>{introDescription}</p>
      <div className={styles.buttonWrapper}>
        <PrimaryButton label={bookNowButton} className={styles.continueButton} onClick={props.navigateNext} />
        {props.displaySkipButton && (
          <GhostButton label={optOutButton} className={styles.optOutButton} onClick={props.optOut} />
        )}
      </div>
    </div>
  );
};

export default JetpassIntro;
